import { QueryConfig } from "@/lib/react-query";
import { useScenarioBuilderClient } from "@/pages/scenario-builder/api/hooks/useScenarioBuilderClient";
import {
  GetSpendConstraintsRequest,
  ScenarioType,
  SpendConstraintsResponse,
} from "@mutiny-group/sbo-openapi-client";
import { useQuery } from "@tanstack/react-query";

export type SpendConstraints = SpendConstraintsResponse;

type SpendConstraintsParams = Omit<
  GetSpendConstraintsRequest,
  "scenarioStartDate" | "scenarioEndDate" | "brand" | "geographies"
>;

type UseSpendConstraintsOptions = SpendConstraintsParams & {
  startDate: string | null;
  endDate: string | null;
  scenarioType: ScenarioType;
  brand?: string | null;
  geography?: string | null;
  config?: QueryConfig<() => Promise<SpendConstraintsResponse>>;
};

export const useSpendConstraints = ({
  startDate,
  endDate,
  scenarioType,
  brand,
  geography,
  config,
  ...params
}: UseSpendConstraintsOptions) => {
  const scenarioBuilderClient = useScenarioBuilderClient();
  const brandParam = !brand || brand === "default" ? null : brand;
  const geographyParam = geography ? [geography] : null;

  return useQuery({
    queryKey: [
      "spend-constraints",
      startDate,
      endDate,
      scenarioType,
      brandParam,
      geographyParam,
      ...Object.entries(params).flat(),
    ],
    queryFn: () =>
      scenarioBuilderClient.spends.getSpendConstraints({
        scenarioStartDate: new Date(startDate!),
        scenarioEndDate: new Date(endDate!),
        ...(brandParam ? { brand: brandParam } : {}),
        ...(geographyParam ? { geographies: geographyParam } : {}),
        ...params,
      }),
    enabled: !!startDate && !!endDate,
    ...config,
  });
};
